





























































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import EventBus from '@/plugins/EventBus'
import { maskDate } from '@/utils/common'
import RecebimentoStore from '@/components/Recebimento/Store/RecebimentoStore'

@Component
export default class ModalTabelaRegrasEquipesMedicas extends Vue {
  readyState = false
  loadTabela = false
  loadProfissionais = false
  loadDelete = ''
  tableSearch = ''
  showModalDelete = false
  itemToDelete: string | null = null

  get getRecebimentoStore() { return getModule(RecebimentoStore, this.$store) }

  get getRegras() { return this.getRecebimentoStore.regrasEquipeMedica }

  get loadingTabela() { return this.loadTabela }
  set loadingTabela(value: boolean) { this.loadTabela = value }

  get getGestoresTableHeader() {
    return [
      { text: 'Regra', class: 'table-headers', align: 'left', value: 'regraCalculoNome' },
      { text: 'Criado por', class: 'table-headers', align: 'left', value: 'createdByNome' },
      { text: 'Criado em', class: 'table-headers', align: 'left', value: 'createdOn' },
    ]
  }

  get showModal() {
    return this.getRecebimentoStore.modalTabelaRegras
  }

  set showModal(value: boolean) {
    this.getRecebimentoStore.setModalTabelaRegras(value)
  }

  maskDate(date: string) {
    return maskDate(date)
  }

  @Watch('showModal')
  onChangeShowModal(value: boolean) {
    if (!value) {
      this.tableSearch = ''
    }
  }
}
